import React, { useState, useRef, useEffect } from "react";
import {
  Backdrop,
  Button,
  FormFieldSet,
  LogoLoader,
  Modal,
  showToast,
  TableAdv,
} from "../../../../../components";
import { mapTableRows } from "../../../../../utils";
import { useSelector } from "react-redux";
import { getAllIntegrationAccess } from "../../../../../redux/slices/setting/settingApi";
import { bulkResumeParser } from "../../../../../redux/slices/recruitmentSourcing/SourcingApi";
import { trackEvent } from "../../../../../utils/mixpanelService";

const BulkModal = ({ isOpen, onClose,accessId }) => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [defaultSource, setDefaultSource] = useState("");
  const [loading,setLoading] = useState(false);
  const fileInputRef = useRef(null);
  // const [accessId,setAccessId] = useState(null);
  const [operation, setOperation] = useState("overwrite");
  const { user } = useSelector((state) => state.auth);
  const handleAddFilesClick = () => {
    fileInputRef.current.click();
  };
  const handleDefaultSourceChange = (value) => {
    setDefaultSource(value);
    setUploadedFiles((prevFiles) =>
      prevFiles.map((file) => ({
        ...file,
        source: value,
      }))
    );
  };

  const handleSourceChange = (fileId, newSource) => {
    setUploadedFiles((prevFiles) =>
      prevFiles.map((file) =>
        file.id === fileId ? { ...file, source: newSource } : file
      )
    );
  };

  // const handleFileChange = (e) => {
  //   if (!e.target.files || e.target.files.length === 0) {
  //     e.target.value = null;
  //     return;
  //   }
  //   const filesArray = Array.from(e.target.files);
  //   if (uploadedFiles.length + filesArray.length > 50) {
  //     alert("Maximum 50 files allowed");
  //     e.target.value = null;
  //     return;
  //   }
  //   const maxFileSize = 5 * 1024 * 1024;
  //   const maxTotalSize = 10 * 1024 * 1024;
  //   let totalSize = uploadedFiles.reduce((sum, file) => sum + file.size, 0);
  //   for (let file of filesArray) {
  //     if (file.size > maxFileSize) {
  //       alert(`File "${file.name}" exceeds 5MB limit`);
  //       e.target.value = null;
  //       return;
  //     }
  //     totalSize += file.size;
  //   }
  //   if (totalSize > maxTotalSize) {
  //     alert("Total file size exceeds 10MB limit");
  //     e.target.value = null;
  //     return;
  //   }

  //   const newFiles = filesArray.map((file, index) => ({
  //     id: Date.now() + index,
  //     file: file,
  //     fileName: file.name,
  //     size: file.size,
  //     storage: formatFileSize(file.size),
  //     source: defaultSource,
  //   }));

  //   setUploadedFiles([...uploadedFiles, ...newFiles]);

  //   e.target.value = null;
  // };
  const handleFileChange = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      e.target.value = null;
      return;
    }
    const filesArray = Array.from(e.target.files);

    const duplicateFiles = filesArray.filter((newFile) =>
      uploadedFiles.some(
        (existingFile) => existingFile.fileName === newFile.name
      )
    );

    if (duplicateFiles.length > 0) {
      showToast(
        `File(s) already added: ${
          (duplicateFiles.map((f) => f.name).join(", "))
        }`, "error"
      );
      e.target.value = null;
      return;
    }

    if (uploadedFiles.length + filesArray.length > 50) {
      alert("Maximum 50 files allowed");
      e.target.value = null;
      return;
    }
    const maxFileSize = 5 * 1024 * 1024;
    const maxTotalSize = 10 * 1024 * 1024;
    let totalSize = uploadedFiles.reduce((sum, file) => sum + file.size, 0);
    for (let file of filesArray) {
      if (file.size > maxFileSize) {
        alert(`File "${file.name}" exceeds 5MB limit`);
        e.target.value = null;
        return;
      }
      totalSize += file.size;
    }
    if (totalSize > maxTotalSize) {
      alert("Total file size exceeds 10MB limit");
      e.target.value = null;
      return;
    }

    const newFiles = filesArray.map((file, index) => ({
      id: Date.now() + index,
      file: file,
      fileName: file.name,
      size: file.size,
      storage: formatFileSize(file.size),
      source: defaultSource,
    }));

    setUploadedFiles([...uploadedFiles, ...newFiles]);

    e.target.value = null;
  };
  const formatFileSize = (bytes) => {
    if (bytes < 1024) return bytes + " B";
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + " KB";
    return (bytes / (1024 * 1024)).toFixed(2) + " MB";
  };

  const handleDeleteFile = (fileId) => {
    setUploadedFiles(uploadedFiles.filter((file) => file.id !== fileId));
  };

  const columns = [
    { key: "sNo", label: "S.No" },
    {
      key: "fileName",
      label: "File Name",
    },
    {
      key: "storage",
      label: "Storage",
    },
    {
      key: "source",
      label: "Source",
      width: 160,
      render: (row) => (
        <div className="w-[140px]">
          <FormFieldSet
            type="select"
            noTitle
            size="sm"
            placeholder="Select"
            value={row.source}
            onChange={(value) => handleSourceChange(row.id, value)}
            options={[
              { label: "Career Builder", value: 1 },
              { label: "Dice", value: 2 },
              { label: "LinkedIn", value: 3 },
              { label: "Monster", value: 4 },
            ]}
          />
        </div>
      ),
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <Button
          type="icon"
          color="danger"
          variant="text"
          icon={"delete"}
          size="sm"
          onClick={() => handleDeleteFile(row.id)}
        />
      ),
    },
  ];

  const rows = uploadedFiles.map((file, index) => ({
    sNo: index + 1,
    id: file.id,
    fileName: file.fileName,
    storage: file.storage,
    source: file.source,
  }));

  const handleCloseModal = () => {
    setUploadedFiles([]);     
    setDefaultSource("");    
    setOperation("overwrite");
    onClose();        
  };

  const handleStartParse = async () => {
    if (uploadedFiles.length === 0) {
      showToast("Please upload at least one file before parsing.", "error");
      return;
    }
    if (!accessId) {
      showToast("Access not found!", "error");
      return;
    }
    const formData = new FormData();

    uploadedFiles.forEach((file) => {
      formData.append("doc", file.file);
    });

    formData.append("coll", "Candidate");
    formData.append("accessId", accessId);
    formData.append("operation", operation);
    formData.append("addedBy", user.data.uiid);

    const sources = uploadedFiles.map((f) => f.source);
    formData.append("sources", JSON.stringify(sources));
    try {
      setLoading(true);
      const response = await bulkResumeParser(formData);
      console.log("Parse success:", response.data);
      const resData = response?.data?.data;
      if (resData) {
        const { newApplicant = [], existingApplicant = [], failedResumes = [] } = resData;

        showToast("Bulk parse completed!", "success", 2000);
          trackEvent({
                    eventName:"Bulk_Parse",
                  })
        const successList = [
          ...newApplicant.map((f) => f.fileName),
          ...existingApplicant.map((f) => f.fileName),
        ];

        if (successList.length > 0) {
          const successText = successList.join(", ");
          showToast(`Successfully processed: ${successText}`, "success", 4000);
        }

        if (failedResumes.length > 0) {
          failedResumes.forEach((fail) => {
            showToast(
              `❌ ${fail.fileName} — ${fail.error}`,
              "error",
              5000
            );
          });
        }
        handleCloseModal();
      } else {
        showToast("Error parsing resumes!", "error", 2000);
      }
    } catch (error) {
      console.error("Error parsing files:", error);
      showToast("Error while parsing files. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };


  // const fetchIntegrationAccess = async () => {
  //   // setLoader(true);
  //   try {
  //     const params = {
  //       coll: "IntegrationAccess",
  //       fil: {
  //         userId: {
  //           type: "FIND_INTIGRATION_ACCESS",
  //           value: user?.data?.uiid,
  //           category: 6,
  //           categoryType: 1,
  //         },
  //       },
  //       useAggregate: true,
  //     };

  //     const response = await getAllIntegrationAccess(params);
  //     // console.log("response",response)

  //   const status = response?.data?.data?.[0]?.integrationData?.status;
  //   const uiid = response?.data?.data?.[0]?.uiid || null;
  //     if (typeof status !== "undefined") {
  //       if (status === 1) {
  //         setAccessId(uiid)
  //       } else {
  //         showToast("Open AI integration access not found. Please contact the administrator", "error");
  //       }
  //     } else {
  //       showToast("Open AI integration status not found", "error");
  //     }

  //   } catch (err) {
  //     console.error("Error fetching integration access:", err);
  //   } finally {
  //     // setLoader(false);
  //   }
  // };
  // useEffect(() =>{
  //   fetchIntegrationAccess();
  // },[])
  const mappedRows = mapTableRows(rows, columns);

  return (
    <div>
      <Modal
        isOpen={isOpen}
        onClose={handleCloseModal}
        width="max-w-4xl"
        title={"Upload Files"}
      >
        <div className="grid grid-cols-2 gap-2">
          <FormFieldSet
            title="Default Option When System Finds Duplicate Resume"
            placeholder="Keep Both"
            type="select"
            options={[
              { label: "Overwrite", value: "overwrite" },
              { label: "Keep Both", value: "keep both" },
            ]}
            value={operation}
            onChange={(value) => setOperation(value)}
          />
          <FormFieldSet
            title="Select Source"
            placeholder="Select"
            type="select"
            value={defaultSource}
            // onChange={(value) => setDefaultSource(value)}
            onChange={handleDefaultSourceChange}
            options={[
              { label: "Career Builder", value: 1 },
              { label: "Dice", value: 2 },
              { label: "LinkedIn", value: 3 },
              { label: "Monster", value: 4 },
            ]}
          />
          <div className="flex items-center col-span-2 my-4">
            <input
              type="file"
              ref={fileInputRef}
              className="hidden"
              onChange={handleFileChange}
              multiple
              accept=".pdf,.doc,.docx"
            />
            <Button
              onClick={handleAddFilesClick}
              variant="text"
              icon={"add_circle"}
              title={"Add Files"}
            />
            <span className="text-sm text-gray-300">
              (Max 5 MB each Max 50 Files Total less than or equal to 10MB)
            </span>
          </div>
        </div>

        {uploadedFiles.length > 0 && (
          <TableAdv rows={mappedRows} columns={columns} tableId={"applicant_bulkmodal"} hideToolBar />
        )}

        <div className="flex gap-2 items-center justify-end my-6 mx-4">
          <Button
            variant="outlined"
            title={"Cancel"}
            size="sm"
            // onClick={onClose}
            onClick={handleCloseModal}
          />
          <Button title={"Start Parse"} size="sm" onClick={handleStartParse} />
        </div>
        <Backdrop isOpen={loading}>
          <LogoLoader />
        </Backdrop>
      </Modal>
    </div>
  );
};

export default BulkModal;
